<div
  class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
  style="
    background-image: url('assets/images/dashboard/login.avif');
    overflow-y: scroll;
    margin: auto;
    height: 100vh;
  "
  id="mainDiv"
>
  <div
    class="auth-block center-div"
    style="
      text-align: center;
      background-color: white;
      border-radius: 10px;
      padding: 2%;
      width: fit-content;
      margin-bottom: 40px;
    "
  >
    <div style="text-align: center; padding: 2% 0">
      <img
        alt=""
        ng-src="assets/images/dashboard/unified-ai-logo-blue.avif"
        height="50"
        width="201"
        src="assets/images/dashboard/unified-ai-logo-blue.avif"
      />
      <div
        *ngIf="!isFormSubmitted"
        class="col-xs-12 col-sm-12 col-md-12"
        style="
          display: inline-flex;
          padding: 10px 40px;
          cursor: pointer;
          font-size: 16px;
        "
      >
        <div
          (click)="selectedSignupChange('self')"
          (keydown)="selectedSignupChange('self')"
          style="padding: 1% 3% 1% 1%"
        >
          <input
            style="cursor: pointer; display: inline"
            type="radio"
            value="self"
            id="self"
            class="radio_activity"
            [checked]="selectedSignupOption === 'self'"
          />
          &nbsp;<span class="radioOnboard"
            ><label for="self">{{ 'login.self' | translate }}</label></span
          >
        </div>
        <div
          (click)="selectedSignupChange('reseller')"
          (keydown)="selectedSignupChange('reseller')"
          style="padding: 1%"
        >
          <input
            style="cursor: pointer; display: inline"
            type="radio"
            value="reseller"
            id="reseller"
            class="radio_activity"
            [checked]="selectedSignupOption === 'reseller'"
          />
          &nbsp;<span class="radioOnboard"
            ><label for="reseller">{{
              'login.certifiedPartner' | translate
            }}</label></span
          >
        </div>
      </div>
      <div *ngIf="selectedSignupOption === 'self'">
        <app-self-service-onboard
          (dataEmitter)="handleReceivedData($event)"
          [user]="userInfo"
          [resetForm]="resetForm"
        ></app-self-service-onboard>
      </div>
      <div *ngIf="selectedSignupOption === 'reseller'" style="width: 500px">
        <form [formGroup]="UserForm" (ngSubmit)="onSignUp()">
          <div
            class="col-xs-12 col-sm-12 col-md-12"
            style="
              margin-top: 20px;
              margin-left: 26px;
              height: fit-content;
              max-height: 65vh;
              overflow-y: scroll;
              padding: 0;
            "
          >
            <div id="loginlicensekey" class="col-xs-12 col-sm-12 col-md-12">
              <div
                class="col-xs-8 -group login-input"
                style="padding: 0"
                [ngStyle]="{ 'margin-bottom': showInfo ? '0px' : '55px' }"
              >
                <div
                  class="inputContainer col-xs-12 col-sm-12 col-md-12"
                  style="
                    position: relative;
                    top: -24px;
                    padding: 0;
                    margin-bottom: 0;
                  "
                >
                  <em class="fas fa-key licenseKey"></em>
                  <input
                    type="text"
                    id="loginLicensekeyInput"
                    [attr.aria-label]="'login.licensekey' | translate"
                    class="form-control Field"
                    name="validatekey"
                    formControlName="licensekey"
                    placeholder="{{ 'login.licensekey' | translate }}"
                    style="
                      border-radius: 5px;
                      color: #333333 !important;
                      width: 100%;
                      margin-top: -2.7rem;
                      margin-bottom: 0;
                    "
                    (keydown)="verifyKey()"
                    (keyup)="verifyKey()"
                    autocomplete="off"
                    required
                  />
                </div>
                <div
                  class="col-xs-12 col-sm-12 col-md-12"
                  style="top: -20px"
                  *ngIf="
                    clickValidate &&
                    ((UserForm.controls['licensekey'].invalid &&
                      UserForm.controls['licensekey'].errors.required) ||
                      (!showInfo && UserForm.controls['licensekey'].valid))
                  "
                >
                  <div
                    *ngIf="
                      clickValidate &&
                      UserForm.controls['licensekey'].invalid &&
                      UserForm.controls['licensekey'].errors.required
                    "
                    class="text-danger"
                  >
                    {{ 'login.key_required' | translate }}
                  </div>
                  <div *ngIf="clickValidate && !showInfo" class="text-danger">
                    <div
                      *ngIf="
                        clickValidate &&
                        !showInfo &&
                        UserForm.controls['licensekey'].valid
                      "
                    >
                      {{ validationMsg }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="form-group col-xs-4 login-input submit"
                style="display: flex"
              >
                <button
                  id="licenseValidation"
                  class="form-control btn-auth"
                  style="
                    background-color: #386ba7;
                    border-radius: 5px;
                    color: white;
                  "
                  [disabled]="showInfo"
                  type="button"
                  (click)="licenseValidation()"
                >
                  {{ showInfo ? 'VALIDATED' : 'VALIDATE' }}
                </button>
                <em
                  class="fa fa-check-circle"
                  style="
                    font-size: 15px !important;
                    padding-top: 12px;
                    margin-left: 10px;
                    color: green;
                  "
                  aria-hidden="true"
                  *ngIf="showInfo"
                ></em>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 licenceForm">
              <div
                style="margin-left: 5px; margin-right: 30px"
                *ngIf="showInfo"
              >
                <div class="form-group" style="text-align: left">
                  <label for="loginCompanyInput" class="signup-label">{{
                    'login.compnay' | translate
                  }}</label>
                  <div class="inputContainer" id="logincompany">
                    <em
                      class="fas fa-briefcase"
                      style="
                        font-size: medium;
                        margin-top: 8px;
                        margin-left: 8px;
                      "
                    ></em>
                    <input
                      type="text"
                      id="loginCompanyInput"
                      class="form-control Field"
                      name="company"
                      formControlName="company"
                      placeholder="{{ 'login.compnay' | translate }}"
                      style="
                        border-radius: 5px;
                        color: #333333 !important;
                        width: 408px;
                        margin-top: -2.7rem;
                      "
                      autocomplete="off"
                      required
                      readonly
                      [attr.disabled]="true"
                    />
                  </div>
                </div>
              </div>

              <div style="margin-left: 5px" *ngIf="showInfo">
                <div class="form-group" style="text-align: left">
                  <label for="loginusername2" class="signup-label">{{
                    'login.user_name' | translate
                  }}</label>
                  <div class="inputContainer" id="logingusername">
                    <em
                      class="fas fa-user"
                      style="
                        font-size: medium;
                        margin-top: 8px;
                        margin-left: 8px;
                      "
                    ></em>
                    <input
                      type="text"
                      id="loginusername2"
                      class="form-control Field"
                      name="validatekey"
                      formControlName="username"
                      placeholder="{{ 'login.user_name' | translate }}"
                      style="
                        border-radius: 5px;
                        color: #333333 !important;
                        width: 408px;
                        margin-top: -2.7rem;
                      "
                      autocomplete="off"
                      required
                      readonly
                      [attr.disabled]="true"
                    />
                  </div>
                </div>
              </div>

              <div style="margin-left: 5px" *ngIf="showInfo">
                <div class="form-group" style="text-align: left">
                  <label for="loginPassword2" class="signup-label">{{
                    'login.password' | translate
                  }}</label>
                  <div class="inputContainer" id="loginpassword">
                    <em
                      class="fas fa-lock"
                      style="
                        font-size: medium;
                        margin-top: 8px;
                        margin-left: 8px;
                      "
                    ></em>
                    <input
                      id="loginPassword2"
                      type="password"
                      class="form-control Field"
                      name="password"
                      formControlName="password"
                      placeholder="{{ 'login.password' | translate }}"
                      style="
                        border-radius: 5px;
                        color: #333333 !important;
                        background-color: white;
                        width: 408px;
                        margin-top: -2.7rem;
                      "
                      autocomplete="off"
                      required
                    />
                  </div>
                  <div
                    *ngIf="submitted && UserForm.controls['password'].invalid"
                    class="text-danger"
                  >
                    <div *ngIf="UserForm.controls['password'].errors.required">
                      {{ 'login.password_required' | translate }}
                    </div>
                  </div>
                </div>
              </div>

              <div style="margin-left: 5px" *ngIf="showInfo">
                <div class="form-group" style="text-align: left">
                  <label for="loginConfirmPasswordInput" class="signup-label">{{
                    'login.confirm_password' | translate
                  }}</label>
                  <div class="inputContainer" id="loginconfirmpassword">
                    <em
                      class="fas fa-lock"
                      style="
                        font-size: medium;
                        margin-top: 8px;
                        margin-left: 8px;
                      "
                    ></em>
                    <input
                      id="loginConfirmPasswordInput"
                      type="password"
                      class="form-control Field"
                      name="password"
                      formControlName="confirm"
                      placeholder="{{ 'login.confirm_password' | translate }}"
                      style="
                        border-radius: 5px;
                        color: #333333 !important;
                        background-color: white;
                        width: 408px;
                        margin-top: -2.7rem;
                      "
                      autocomplete="off"
                      required
                    />
                  </div>
                  <div
                    *ngIf="
                      passwordValidate &&
                      UserForm.get('confirm').errors.confirmPasswordValidator
                    "
                    class="text-danger"
                  >
                    <div
                      *ngIf="
                        passwordValidate &&
                        UserForm.get('confirm').errors.confirmPasswordValidator
                      "
                    >
                      {{ 'login.password_must_match' | translate }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group" *ngIf="showInfo">
                <button
                  id="loginSignUp"
                  class="form-control"
                  style="
                    background-color: #386ba7;
                    border-radius: 5px;
                    color: white;
                    width: 409px;
                    margin-left: 4px;
                    margin-top: 35px;
                  "
                  type="submit"
                >
                  {{ 'login.sign_up' | translate }}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
